export function distanceToTriggerGrouping(distanceToTrigger, lastPrice) {
  if (!distanceToTrigger || !lastPrice) return 5;
  const percentage = Number(distanceToTrigger) / Number(lastPrice);
  if (percentage <= 0.01) return 1;
  if (percentage <= 0.03) return 2;
  if (percentage <= 0.06) return 3;
  else return 4;
}


